function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m.160156 120h48v144h-48zm0 0",
  fill: "#2d75bb"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m48.160156 136h32v112h-32zm0 0",
  fill: "#50b3c9"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m272.160156 272h96v32h-96zm0 0",
  fill: "#50b3c9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m272.160156 160h-24l-16-32h-96l-16 32h-40v64h176c17.671875 0 32 14.328125 32 32v16h64v-32c0-44.183594-35.820312-80-80-80zm0 0",
  fill: "#86d5e2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m118.585938 167.84375 3.136718-15.691406 40 8-3.136718 15.691406zm0 0",
  fill: "#cdeef6"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m206.636719 160.3125 40.019531-7.992188 3.136719 15.695313-40.019531 7.996094zm0 0",
  fill: "#cdeef6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m152.160156 96h64v32h-64zm0 0",
  fill: "#2d75bb"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m168.160156 64h32v32h-32zm0 0",
  fill: "#195c85"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m96.160156 32h176v32h-176zm0 0",
  fill: "#dd3e46"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m184.160156 0c8.835938 0 16 7.164062 16 16v16h-32v-16c0-8.835938 7.164063-16 16-16zm0 0",
  fill: "#fcf05a"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m128.160156 32h16v32h-16zm0 0",
  fill: "#b11e48"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m176.160156 32h16v32h-16zm0 0",
  fill: "#b11e48"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m224.160156 32h16v32h-16zm0 0",
  fill: "#b11e48"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376.160156 464h-112l24-160h64zm0 0",
  fill: "#cdeef6"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m288.261719 462.683594 16.015625-96 15.785156 2.632812-16.019531 96zm0 0",
  fill: "#86d5e2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328.207031 392.878906 15.902344-1.765625 8 71.996094-15.902344 1.769531zm0 0",
  fill: "#86d5e2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m408.160156 432s-4.378906-38.976562 16-64c20.375-25.023438 58.398438 10.113281 24 32-34.402344 21.886719-40 32-40 32zm0 0",
  fill: "#cdeef6"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m232.160156 448s1.808594-52.648438-24-72c-32-24-60.105468 20.992188-24 40 36.101563 19.007812 48 32 48 32zm0 0",
  fill: "#cdeef6"
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#2d75bb"
}, React.createElement("path", {
  d: "m240.160156 360h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m384.160156 336h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m208.160156 312h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m416.160156 272h16v16h-16zm0 0"
}));

var SvgTap = function SvgTap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "465pt",
    viewBox: "-2 0 465 465.31782",
    width: "465pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tap.1fac14d9.svg";
export { ForwardRef as ReactComponent };